<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.2072 4.62891L8.79297 6.04312L14.7525 12.0027L8.79297 17.9622L10.2072 19.3765L17.581 12.0027L10.2072 4.62891Z"
    fill="white"
  />
</svg>
